<script>
export default {
  name: 'LocalizationMixin',
  watch: {
    club(newval) {
      switch (newval.language) {
        case 0:
          this.$i18n.locale = 'sv';
          break;
        case 1:
          this.$i18n.locale = 'en';
          break;
      }
    },
    businessBoardLanguage(newval) {
      switch (newval) {
        case ('0', 0):
          this.$i18n.locale = 'sv';
          break;
        case ('1', 1):
          this.$i18n.locale = 'en';
          break;
      }
    },
    user(newval) {
      if (!newval.club) return;
      switch (newval.club.language) {
        case ('0', 0):
          this.$i18n.locale = 'sv';
          break;
        case ('1', 1):
          this.$i18n.locale = 'en';
          break;
      }
    },
  },
  computed: {
    businessBoardLanguage() {
      return this.$store.getters['businessboard/language'];
    },
    club() {
      return this.$store.getters['clubs/club'];
    },
    user() {
      return this.$store.getters['users/user'];
    },
    country() {
      if (this.club && this.club.country) return this.club.country;
      if (this.user && this.user.club && this.user.club.country)
        return this.user.club.country;
      return 0; // Default to Swedish if no language is set
    },
    locale() {
      switch (this.country) {
        case 0: // Sweden
          return 'sv';
        case 1: // Norway
          return 'no';
        case 2: // Finland
          return 'fi';
        case 3: // Dennmark
          return 'da';
        case 4: // Iceland
          return 'is';
        case 5: // Estonia
          return 'et';
        case 6: // Germany
          return 'de';
        case 7: // England
          return 'en';
        case 8: // USA
          return 'en';
        case 9: // Poland
          return 'pl';
        case 10: // Spain
          return 'es';
        case 11: // Portugal
          return 'pt';
        case 12: // Netherlands
          return 'nl';
      }
      return 'sv';
    },
    currency() {
      switch (this.country) {
        case 0: // Sweden
          return 'SEK';
        case 1: // Norway
          return 'NOK';
        case 2: // Finland
          return 'EUR';
        case 3: // Dennmark
          return 'DKK';
        case 4: // Iceland
          return 'ISK';
        case 5: // Estonia
          return 'EUR';
        case 6: // Germany
          return 'EUR';
        case 7: // England
          return 'GBP';
        case 8: // USA
          return 'USD';
        case 9: // Poland
          return 'PLN';
        case 10: // Spain
          return 'EUR';
        case 11: // Portugal
          return 'EUR';
        case 12: // Netherlands
          return 'EUR';
      }
      return 'SEK';
    },
  },
  methods: {
    currencyNumber(value) {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
        maximumFractionDigits: 0,
      }).format(value);
    },
  },
  mounted() {},
};
</script>
